import React from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { useUserAuth } from 'common/queries-and-mutations/auth';
import { ErrorFallback } from 'components/ErrorFallback';
import { Loader } from 'components/Loader';
import iWillLogo from '../assets/iWillLogo.png';
import { useAppSelector } from 'store/hooks';
import { selectAccountDetails } from 'selectors/account-selector';

const OnBoardingLayout = () => {
  const { isLoading } = useUserAuth();
  const { user } = useAppSelector(selectAccountDetails);

  return (
    <div>
      {!isLoading && user ? (
        <ErrorBoundary FallbackComponent={ErrorFallback as any}>
          <div className="flex min-h-screen flex-col bg-[#F4F5F6] sm:w-min md:w-full">
            <div className="relative min-h-screen md:flex">
              <div className="flex-1">
                <div>
                  <nav className="top-0 z-50 bg-white p-4 px-2 shadow-xl">
                    <div className="flex items-center justify-center">
                      <img src={iWillLogo} className="h-10 w-32" />
                    </div>
                  </nav>
                </div>
                <div className="p-10 md:px-52">
                  <div className="w-full">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ErrorBoundary>
      ) : (
        <div className="flex min-h-screen items-center justify-center">
          <Loader height={100} width={100} color="#FF7A00" />
        </div>
      )}
    </div>
  );
};

export default OnBoardingLayout;
